import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { TaxOfficeQuery, TaxOfficeQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(TaxOfficeQuery)
@Wrapper(TaxOfficeQueryHandlerBase)
export class TaxOfficeQueryHandler {
    public constructor(
        http: Http
    ) { }
}
